import React, { useState } from 'react';

function StadContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/backend/start-send-email.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSent(true);
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('Något gick fel, försök igen.');
      }
    } catch (error) {
      alert('Fel vid skickande, försök igen senare.');
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div>
        <label className="block text-sm font-medium text-gray-700">Namn</label>
        <input
          type="text"
          name="name"
          className="w-full mt-1 p-2 border border-gray-300 rounded-md"
          placeholder="Ditt namn"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">E-post</label>
        <input
          type="email"
          name="email"
          className="w-full mt-1 p-2 border border-gray-300 rounded-md"
          placeholder="din@epost.se"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Meddelande</label>
        <textarea
          name="message"
          className="w-full mt-1 p-2 border border-gray-300 rounded-md"
          rows="5"
          placeholder="Hur kan vi hjälpa dig?"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </div>
      <button
        type="submit"
        className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition"
      >
        Skicka meddelande
      </button>

      {sent && (
        <p className="mt-4 text-green-600 font-semibold">Mejlet har skickats!</p>
      )}
    </form>
  );
}

export default StadContactForm;
